import { ReactNode, useEffect, useMemo, useState } from "react";
import Draggable, { DraggableEvent } from "react-draggable";
import { usePlaygroundState } from "../usePlaygroundContext";

const ResettableDraggable = ({ children }: { children: ReactNode }) => {
  const { isPlaygroundPopoverOpen } = usePlaygroundState();
  const initialPosition = useMemo(() => ({ x: 0, y: 0 }), []);
  const [dragPosition, setDragPosition] = useState(initialPosition);

  useEffect(() => {
    if (!isPlaygroundPopoverOpen) {
      setDragPosition(initialPosition);
    }
  }, [isPlaygroundPopoverOpen, initialPosition]);

  // Optional: Handler to sync state when dragging stops
  const handleStop = (_e: DraggableEvent, data: typeof initialPosition) => {
    setDragPosition({ x: data.x, y: data.y });
  };

  return (
    <div>
      <Draggable handle=".drag-handle" bounds="body" position={dragPosition} onStop={handleStop}>
        {children}
      </Draggable>
    </div>
  );
};

export default ResettableDraggable;
